import { computed, ref, provide, inject } from "vue";
import { eventBus } from "@/eventBus";
import { resizeAllPlotlyCharts } from "@/utils/plotlyResizeAll";
import {
  SIDEBAR_COLLAPSED_PX,
  SIDEBAR_EXPANDED_PX,
} from "@app/config/navigation";

const SIDEBAR_KEY = Symbol("fd-sidebar");

export function provideSidebar() {
  const collapsed = ref(false);

  function toggle() {
    collapsed.value = !collapsed.value;
    eventBus.emit("resizeChart");
    resizeAllPlotlyCharts();
  }

  function setCollapsed(value) {
    collapsed.value = Boolean(value);
  }

  const widthPx = computed(() =>
    collapsed.value ? SIDEBAR_COLLAPSED_PX : SIDEBAR_EXPANDED_PX
  );

  const api = { collapsed, widthPx, toggle, setCollapsed };
  provide(SIDEBAR_KEY, api);
  return api;
}

export function useSidebar() {
  const api = inject(SIDEBAR_KEY);
  if (!api) {
    throw new Error("useSidebar() must be used inside AppShell");
  }
  return api;
}
